// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 1.5rem;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

button.btn {
  margin-top: 20px;
  margin-right: auto;
}

.text-item {
  direction: ltr !important;
}

span.text {
  color: blue;
}

.text-item {
  font-size: 13px;
  margin-right: 5px;
}

mat-card {
  direction: rtl;
  margin: 15px;
}

.text {
  font-size: 12px;
}

.buttons {
  margin-right: auto;
  margin-top: 20px;
}

.button-style {
  background-color: aliceblue;
  font-size: 12px;
  margin-right: 10px;
  width: 10rem;
}

.text1 {
  color: rgb(103, 125, 143);
}

.text1.ng-star-inserted {
  width: max-content;
  padding: 6px;
  border: groove;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-size: 13px;
  background-color: aliceblue;
  margin-top: 20px;
}

::ng-deep .mat-grid-tile .mat-figure {
  margin-top: 10px;
}

.mat-card:not([class*=mat-elevation-z]) {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.4), 0px 1px 1px 0px rgba(0, 0, 0, 0.4), 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}

.text1 {
  color: rgb(103, 125, 143);
  background-color: aliceblue;
  font-size: 12px;
  margin-right: 5px;
  margin-left: 5px;
  border-radius: 12px;
  width: 150px;
  height: 40px;
  text-align: center;
  padding: 10px;
}

.text1.ng-star-inserted {
  width: max-content;
  padding: 6px;
  border: groove;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-size: 13px;
  background-color: aliceblue;
  margin-top: 20px;
}

.button-back {
  float: left;
  margin-top: 3rem;
  width: 10rem;
}

.button-back {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  margin-right: auto;
  margin-top: 40px;
}

.btn_accept {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  background-color: #2a8954;
  color: white;
}

.btn_reject {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  background-color: #d92727;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/features/verification-bank/verification-bank-detail/verification-bank-detail.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/verification-bank/verification-bank-detail/verification-bank-detail.component.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF;;ADEE;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCJ;;ADCE;EACE,eAAA;EACE,iBAAA;ACEN;;ADAE;EACE,gBAAA;EACA,kBAAA;ACGJ;;ADDA;EACE,yBAAA;ACIF;;ADFA;EACE,WAAA;ACKF;;ADFA;EACE,eAAA;EACA,iBAAA;ACKF;;ADHA;EACE,cAAA;EACA,YAAA;ACMF;;ADHA;EACC,eAAA;ACMD;;ADHA;EACA,kBAAA;EACA,gBAAA;ACMA;;ADHA;EACC,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;ACMD;;ADHA;EACA,yBAAA;ACMA;;ADHA;EACA,kBAAA;EACA,YAAA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;ACMF;;ADJA;EACA,gBAAA;ACOA;;ADJA;EACE,uHAAA;EACA,mBAAA;ACOF;;ADJA;EACE,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;ACOJ;;ADJA;EACE,kBAAA;EACA,YAAA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;ACOJ;;ADJA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;ACOF;;ADLA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;ACQF;;ADNA;EACE,mBAAA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;ACSJ;;ADPA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;ACUF","sourcesContent":["\r\nh1{\r\n  font-size: 1.5rem;\r\n}\r\n  .title{\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  mat-icon{\r\n    font-size: 26px;\r\n      margin-left: 10px;\r\n  }\r\n  button.btn {\r\n    margin-top: 20px;\r\n    margin-right: auto;\r\n}\r\n.text-item{\r\n  direction: ltr !important;\r\n}\r\nspan.text{\r\n  color: blue;\r\n}\r\n\r\n.text-item{\r\n  font-size: 13px;\r\n  margin-right: 5px;\r\n}\r\nmat-card{\r\n  direction: rtl;\r\n  margin: 15px;\r\n}\r\n\r\n.text{\r\n font-size: 12px;\r\n}\r\n\r\n.buttons{\r\nmargin-right: auto;\r\nmargin-top: 20px;\r\n}\r\n\r\n.button-style{\r\n background-color:  aliceblue;\r\n font-size: 12px;\r\n margin-right: 10px;\r\n width: 10rem;\r\n}\r\n\r\n.text1{\r\ncolor: rgb(103, 125, 143);\r\n}\r\n\r\n.text1.ng-star-inserted {\r\nwidth: max-content;\r\npadding: 6px;\r\n  border: groove;\r\n  margin-left: 5px;\r\n  margin-right: 5px;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  background-color:aliceblue ;\r\n  margin-top: 20px;\r\n}\r\n::ng-deep .mat-grid-tile .mat-figure{\r\nmargin-top: 10px;\r\n}\r\n\r\n.mat-card:not([class*=mat-elevation-z]) {\r\n  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 40%), 0px 1px 1px 0px rgb(0 0 0 / 40%), 0px 1px 3px 0px rgb(0 0 0 / 50%);\r\n  border-radius: 20px;\r\n}\r\n\r\n.text1{\r\n  color: rgb(103, 125, 143);\r\n  background-color: aliceblue;\r\n  font-size: 12px;\r\n  margin-right: 5px;\r\n  margin-left: 5px;\r\n  border-radius: 12px;\r\n    width: 150px;\r\n    height: 40px;\r\n    text-align: center;\r\n    padding: 10px;\r\n}\r\n\r\n.text1.ng-star-inserted {\r\n  width: max-content;\r\n  padding: 6px;\r\n    border: groove;\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    border-radius: 10px;\r\n    font-size: 13px;\r\n    background-color:aliceblue ;\r\n    margin-top: 20px;\r\n}\r\n\r\n.button-back{\r\n  float: left;\r\n  margin-top: 3rem;\r\n  width: 10rem;\r\n}\r\n.button-back{\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 120px;\r\n  margin-right: auto;\r\n  margin-top: 40px;\r\n}\r\n.btn_accept {\r\n  border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 150px;\r\n    border: 2px solid #eee;\r\n    background-color: #2a8954;\r\n    color: white;\r\n}\r\n.btn_reject{\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 150px;\r\n  border: 2px solid #eee;\r\n  background-color: #d92727;\r\n  color: white;\r\n}","h1 {\n  font-size: 1.5rem;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nbutton.btn {\n  margin-top: 20px;\n  margin-right: auto;\n}\n\n.text-item {\n  direction: ltr !important;\n}\n\nspan.text {\n  color: blue;\n}\n\n.text-item {\n  font-size: 13px;\n  margin-right: 5px;\n}\n\nmat-card {\n  direction: rtl;\n  margin: 15px;\n}\n\n.text {\n  font-size: 12px;\n}\n\n.buttons {\n  margin-right: auto;\n  margin-top: 20px;\n}\n\n.button-style {\n  background-color: aliceblue;\n  font-size: 12px;\n  margin-right: 10px;\n  width: 10rem;\n}\n\n.text1 {\n  color: rgb(103, 125, 143);\n}\n\n.text1.ng-star-inserted {\n  width: max-content;\n  padding: 6px;\n  border: groove;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  font-size: 13px;\n  background-color: aliceblue;\n  margin-top: 20px;\n}\n\n::ng-deep .mat-grid-tile .mat-figure {\n  margin-top: 10px;\n}\n\n.mat-card:not([class*=mat-elevation-z]) {\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.4), 0px 1px 1px 0px rgba(0, 0, 0, 0.4), 0px 1px 3px 0px rgba(0, 0, 0, 0.5);\n  border-radius: 20px;\n}\n\n.text1 {\n  color: rgb(103, 125, 143);\n  background-color: aliceblue;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-left: 5px;\n  border-radius: 12px;\n  width: 150px;\n  height: 40px;\n  text-align: center;\n  padding: 10px;\n}\n\n.text1.ng-star-inserted {\n  width: max-content;\n  padding: 6px;\n  border: groove;\n  margin-left: 5px;\n  margin-right: 5px;\n  border-radius: 10px;\n  font-size: 13px;\n  background-color: aliceblue;\n  margin-top: 20px;\n}\n\n.button-back {\n  float: left;\n  margin-top: 3rem;\n  width: 10rem;\n}\n\n.button-back {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  margin-right: auto;\n  margin-top: 40px;\n}\n\n.btn_accept {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  background-color: #2a8954;\n  color: white;\n}\n\n.btn_reject {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  background-color: #d92727;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
